import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import SellYearReportForm from "@components/dynamic/SellYearReportForm";

const SellByYearReport = () => {
  useEffect(() => {
  }, []);


  return (
    <PageContainer
      title="Reporte de Ventas por año"
      backUrl="/user/dashboard-accounting"
    >
      <SellYearReportForm />
    </PageContainer >
  );
}

export default SellByYearReport;
